<template>
  <div
    v-if="stats.value && stats.value.time"
    class="rt-main"
  >
    <el-card
      shadow="never"
      class="rt-card rt-kpi-card"
    >
      <div class="rt-card-head">
        <span class="rt-title">RealTime Overview</span>
        <span class="rt-update">{{ showTime(stats.value.time) }}</span>
      </div>
      <statisticsRealtime
        v-if="stats.value"
        :stats="stats.value"
      />
    </el-card>

    <el-row
      :gutter="16"
      class="rt-tables"
    >
      <el-col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="12"
      >
        <el-card
          shadow="never"
          class="rt-card table-card"
        >
          <div class="rt-card-head">
            <span class="rt-title">Agents</span>
            <span class="rt-update">{{ showTime(stats.value.time) }}</span>
          </div>
          <realUsers :users="stats.value.users" />
        </el-card>
      </el-col>
      <el-col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="12"
      >
        <el-card
          shadow="never"
          class="rt-card table-card"
        >
          <div class="rt-card-head">
            <span class="rt-title">Recently Rooms</span>
            <span class="rt-count">{{ (stats.value.rooms || []).length }} rooms</span>
          </div>
          <realRooms :users="stats.value.rooms" />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import statisticsRealtime from '@/views/home/statistics-realtime'
import realUsers from '@/views/report/real-time/real-time-users'
import realRooms from '@/views/report/real-time/real-time-rooms'
import { getRealTimeUsersStats } from '@/api/report'
import { convertDateTime } from '@/utils/util'
import { onMounted, reactive, onBeforeUnmount } from '@vue/runtime-core'
import { ElMessage } from 'element-plus'

const stats = reactive({
  value: {},
})
let timer = null

async function getStatsRealTime() {
  try {
    const { data: statResult } = await getRealTimeUsersStats()
    stats.value = statResult;
  } catch (e) {
    ElMessage.error('Failed to load data')
  }
}

function showTime(time) {
  return "update time: " + convertDateTime(new Date(time - 60000), 'HH:mm')
}

onMounted(async () => {
  await getStatsRealTime()
  timer = setInterval(getStatsRealTime, 30000)
})

onBeforeUnmount(() => {
  clearInterval(timer);
})
</script>

<style scoped>
.rt-card {
  border-radius: 10px;
  margin-bottom: 16px;
}
.rt-card :deep(.el-card__body) {
  padding: 16px 18px;
}
.rt-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}
.rt-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--el-text-color-primary, #303133);
}
.rt-update,
.rt-count {
  font-size: 12px;
  color: var(--el-text-color-secondary, #909399);
  font-variant-numeric: tabular-nums;
}
.rt-kpi-card :deep(.kpi-grid) {
  margin-bottom: -16px;
}
.rt-tables {
  display: flex;
  flex-wrap: wrap;
}
.rt-tables .el-col {
  display: flex;
}
.table-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.table-card :deep(.el-card__body) {
  flex: 1;
}
</style>
